export default __webpack_public_path__ + "f26e6cab3f0bab8661be287d45e8add7.png";